import httpManager from "@/app/shared/utils/httpManager";

/**
 * Descarga la plantilla para cargar las opciones de un campo tipo select.
 *
 * @param {number} portfolioId Identificador de la campaña.
 * @param {string} fieldName Nombre técnico del campo.
 *
 * @return {Promise<Blob>} Plantilla Excel.
 */
export async function downloadTemplateFieldOptions(portfolioId, fieldName) {
  const response = await httpManager.getBlob(
    `/portfolios/${portfolioId}/template/fields/${encodeURIComponent(fieldName)}/options/template/`,
  );

  return response.data;
}
